import { render, staticRenderFns } from "./NuevoMovimiento.vue?vue&type=template&id=cdc047d6&scoped=true&"
import script from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimiento.vue?vue&type=style&index=0&id=cdc047d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc047d6",
  null
  
)

export default component.exports